<script>
    import Header from '../header.svelte';
    import Checkbox  from '@smui/checkbox/styled';
    import FormField from '@smui/form-field/styled';
	import { page_setting_store, user_store, api_host } from '../../stores.js';
    import { getToken, doFetch } from '../../utils/Fetching.js';
    import { toast_message } from '../../utils/toast_message.js';
    import { handle_not_subscribed } from '../../utils/format.js';
    import { init_data } from '../../init.js';
    import { onMount } from 'svelte';
       
    
    let myself = {};
    let is_busy;

    let config_lawn_settings = {};
    let config_service_settings = {};
    let config_weekdays_settings = {};
    let config_time_preference_settings = {};
    let config_service_type_settings = {};
    let config_service_type_keys = [];
    let config_landing_page_menu = {};

    const default_service_type_options = [
		"Yard/Lawn Service",
		"Irrigation Service",
		"Tree Service",
		"Plant Service",
		"Hardscape Service",
		"Snow Service",
		"Other Service"
    ];

    let temp_service_type = '';
    let adding_service_type = false;
    const toggle_adding_service_type = () => {
        adding_service_type = !adding_service_type;
    }
    const add_service_type = () => {
        if (temp_service_type.trim() == '' || Object.keys(config_service_type_settings).includes(temp_service_type)) {
            toast_message(false, 'The service type is not valid.', 2000);
            return;
        }
        let max_value = 1;
        config_service_type_keys.forEach(key => {
            if (max_value < config_service_settings[key]) max_value = config_service_settings[key];
        });
        config_service_type_keys.push(temp_service_type);
        config_service_type_settings[temp_service_type] = max_value + 1;
        temp_service_type = '';
        console.log(config_service_type_settings);
    }
    const remove_service_type = (deleted_key) => {
        if (!confirm(`Delete this service type?`)) return;
        config_service_type_keys = config_service_type_keys.filter(key => key != deleted_key);
        delete config_service_type_settings[deleted_key];
        config_service_type_settings = config_service_type_settings;

        toast_message(true, `The service type '${deleted_key}' is deleted.`, 2000);
    }
    
    user_store.subscribe(value => {
        myself = value;
    });

    page_setting_store.subscribe(page_setting => {
        console.log('page_setting_store subscribe');
        if(page_setting.lawn_options == undefined) return;
        config_lawn_settings = page_setting.lawn_options;
        config_service_settings = page_setting.service_frequency_options;
        config_weekdays_settings = page_setting.weekdays_options;
        config_time_preference_settings = page_setting.time_preference_options;
        config_service_type_settings = page_setting.service_type_options;
        config_service_type_keys = Object.keys(config_service_type_settings).sort((a, b) => config_service_type_settings[a] - config_service_type_settings[b]);
        config_landing_page_menu = page_setting.landing_page_menu;
    });

    const save_settings = async () => {
        if (myself['is_subscribed'] !== undefined && !myself['is_subscribed']) {
            handle_not_subscribed(myself.is_authenticated, myself.is_domain_expired);
            return;
        }

        if (Object.keys(config_lawn_settings).filter(key => config_lawn_settings[key]).length < 1 ||
            Object.keys(config_service_settings).filter(key => config_service_settings[key]).length < 1 ||
            Object.keys(config_weekdays_settings).filter(key => config_weekdays_settings[key]).length < 1 ||
            Object.keys(config_time_preference_settings).filter(key => config_time_preference_settings[key]).length < 1 ||
            Object.keys(config_landing_page_menu).filter(key => config_landing_page_menu[key]).length < 1) {
            toast_message(false, 'You must select at least one option.', 2000);
            return;
        }
        is_busy = true;

        const new_service_type_settings = {};
        for (const key in config_service_type_settings) {
            if (config_service_type_keys.includes(key)) new_service_type_settings[key] = config_service_type_settings[key];
        }
        const payload = {
            lawn_options: config_lawn_settings,
            service_frequency_options: config_service_settings,
            weekdays_options: config_weekdays_settings,
            time_preference_options: config_time_preference_settings,
            service_type_options: new_service_type_settings,
            landing_page_menu: config_landing_page_menu,
        };

        const { auth_type, auth_token, domain_code } = getToken();
        const turl = api_host + "/api/landscaper/update/page_setting";
        const headers = { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' };
        const res = await doFetch(turl, 'POST', payload, headers);
        if (res.status) {
            toast_message(true, res.msg, 2000);
            init_data('pages');
        } else {
            toast_message(false, res.msg, 2000);
        }
        is_busy = false;
    }

    onMount(() => {
    });
</script>

<Header title="Settings - Page" bind:is_busy={is_busy} />

<div class="pagesetting-container">
    <div style="display: flex; flex-direction: row; flex-wrap:wrap;">
        <div class="pagesetting-column">
            <div class='pagenote service'>
                <p>Lawn options on the booking page:</p>
            </div>
            <div class="options">
                {#each Object.entries(config_lawn_settings) as [option, checked] }
                <div style="max-width: 300px;">
                    <FormField align="end">
                        <Checkbox  bind:checked={config_lawn_settings[option]}  />
                        <span>{option}</span>
                    </FormField>
                </div>
                {/each}
                
            </div>
            <div class='pagenote service'>
                <p>Service weekdays on the booking page:</p>
            </div>
            <div class="options">
                {#each Object.entries(config_weekdays_settings) as [option, checked] }
                    <div style="max-width: 300px;">
                        <FormField align="end">
                            <Checkbox  bind:checked={config_weekdays_settings[option]} />
                            <span>{option}</span>
                        </FormField>
                    </div>
                {/each}
                
            </div>
            <div class='pagenote service'>
                <p>Service Types:</p>
            </div>
            <div class="options">
                {#each config_service_type_keys as option }
                    <div style="max-width: 300px;">
                        <FormField align="end">
                            <Checkbox  bind:checked={config_service_type_settings[option]} />
                            <span>{option}</span>
                            {#if !default_service_type_options.includes(option)}
                            <button class="btn-icon" on:click={remove_service_type(option)}><i class="fa fa-trash"></i></button>
                            {/if}
                        </FormField>
                    </div>
                {/each}
                {#if adding_service_type}
                <div style="display: flex;">
                    <input
                        bind:value={temp_service_type}
                    />
                    <button style="margin-left: 10px;" class="save" on:click={add_service_type}>Add</button>
                    <button style="margin-left: 10px;" on:click={toggle_adding_service_type}>Cancel</button>
                </div>
                {:else}
                <button class="save" on:click={toggle_adding_service_type}><i class="fa-plus" style="font-style: normal;"></i> Add</button>
                {/if}
            </div>
            <div class='pagenote service'>
                <p>Menu items on the booking page:</p>
            </div>
            <div class="options">
                {#each Object.entries(config_landing_page_menu) as [option, checked] }
                    <div style="max-width: 300px;">
                        <FormField align="end">
                            <Checkbox  bind:checked={config_landing_page_menu[option]} />
                            <span>{option}</span>
                        </FormField>
                    </div>
                {/each}
            </div>
        </div>
        <div class="pagesetting-column">
            <div class='pagenote service'>
                <p>Service frequency on the booking page:</p>
            </div>
            <div class="options">
                {#each Object.entries(config_service_settings) as [option, checked] }
                    <div style="max-width: 300px;">
                        <FormField align="end">
                            <Checkbox  bind:checked={config_service_settings[option]} />
                            <span>{option}</span>
                        </FormField>
                    </div>
                {/each}
                
            </div>
            <div class='pagenote service'>
                <p>Time preferences on the booking page:</p>
            </div>
            <div class="options">
                {#each Object.entries(config_time_preference_settings) as [option, checked] }
                    <div style="max-width: 300px;">
                        <FormField align="end">
                            <Checkbox  bind:checked={config_time_preference_settings[option]} />
                            <span>{option}</span>
                        </FormField>
                    </div>
                {/each}
                
            </div>
        </div>
    </div>
   
    {#if myself.role !== 'manager'}
    <div class="updatebutton">
        <button class="save" on:click={save_settings} disabled={is_busy}>Save Settings</button>
    </div>
    {/if}
</div>

<style>
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    }
    .pagesetting-container {
        margin-top: 15px;
        place-items: center;
    }
    .pagesetting-column {
        width: 50%;
    }
    .pagenote {
        grid-area: pn;
    }
    .service {
        margin-top: 15px;
    }
    .pagenote p {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 0px;
    }
    .options {
        margin-left: 15px;
    }
    .updatebutton {
        margin-top: 15px;
        display: flex;
        flex-direction: row;
        justify-content: start;
    }
    .updatebutton .save {
        width: 200px;
    }

    .save {
        background-color: #357a38;
        color: white;
    }

    .btn-icon {
        border: none;
    }
    .btn-icon:focus {
        outline: none;
    }
    
    @media (max-device-width: 1024px), (max-width: 1023px) {
        .pagesetting-column {
            width: 100%;
        }
    }
</style>